import React from 'react'
import { useEffect, useState, useRef, useImperativeHandle, forwardRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { AgGridReact } from "ag-grid-react";
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryRemarks from "../components/EntryRemarks";
import EntryGrid from "../components/EntryGridAr";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import WashGrid from "../components/WashGrid";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import GridPanelControl from "../components/GridPanelControl";
import ListEditRenderer from "../components/RenderListEdit";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, initializedata, Getstorage, Savestorage, NumConv, DeepCopy, isEnabled,
    getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, GetDesitRound, DicVal, RandomKey, customTarget
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, reports, gridmaximize, setgridlist} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { themeBalham } from 'ag-grid-community';

const totalstylecolor = '#e8ece9';
const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Product = props => {
    const GridPanelStorageKey = "Product_GridPanel";   //GridPanel最大化フラグ保存キー
    const panelsdef = [];
    const inittag = [{ value: '0', label: '本体', }];
    //SIZEDTL未対応 v1.4
    const G_id = {
        BASE: "0", COL: "2", SIZE: "3", SKU: "4", SIZEITEM: "5", SIZEDTL: "6",
        RAW1: "7", RAW2: "8", RAW3: "9", PROCESS: "10", COMP: "11",  ATTN: "13", DEME: "14", ROW: "16", RAW4: "17", SKUM: "18",
        IMAGE: "pic", FILE: "file", WASH:"wash",NB:"nb"
    }
    const primarykeys = ["d_prod_code", "d_prod_color_key", "d_prod_size_key", "d_prod_sku_key", "d_prod_raw_key", "d_prod_proc_key", "d_prod_tag_key", "d_prod_comp_key","d_prod_attn_key", "d_prod_deme_key", "d_prod_wtag_key", "d_prod_row_key"];
    const formid = getformid("Product", props.location.search);
    const controller = getcontroller("Product", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const sizedtlcolDefsInit = [{
        field: 'item', colId: 'item', headerName: "項目", lockPosition: true,
        width: 200, editable: false, filter: false, sortable: false, resizable: true
     }];
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State


    const gridSizeDtlRef = useRef();    //grid api

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [gallery, setgallery] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [taglist, settaglist] = useState(inittag);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const AcceptNo = useRef({ no: "" });
    const search = useLocation().search;
    const reportsRef = useRef(null);
    const GridPanelRef = useRef(null);      //最大化状態

    const tagnoRef = useRef('0');
    const childCompRef = useRef(null);
    const childWashRef = useRef(null);
    const childAttnRef = useRef(null);
    const childDemeRef = useRef(null);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  

    const compbytagRef = useRef([]);
    const washbytagRef = useRef([]);
    const attnbytagRef = useRef([]);
    const demebytagRef = useRef([]);

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function GridColDef(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolRefs.current[gidx].current;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }


    const actionurl = {
        "insert": "product/Insert",
         "update": "product/Update",
         "delete": "product/Delete",
         "saveas": "product/SaveAs",
        "storageadd": "product/AddStorage",
        "storagerowdel": "product/StorageRowdel",
         "upload": "product/Upload",
         "masonry": "product/Masonry",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep1" },
        { status: "ENTRY FORM", menuid: "jan", icon: "", label: "JANコード発行", title: "JANコードの発行を行います" },
        { status: "ENTRY FORM", menuid: "sep2" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep3" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep4" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }

    function onDragEnter(e){
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;

                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    let gridmaxinit = {};
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        gridmaxinit[fnc.current.GridID(panel)] = false;
                        idx++;
                    });
                    dispatch(setgridlist(glist));

                    //パネル最大化Flag
                    var gridmax = Getstorage(corpkey, account, GridPanelStorageKey);    //保存データ
                    if (isEmpty(gridmax)) {
                        gridmax = gridmaxinit;
                    }
                    GridPanelRef.current = gridmax
                    dispatch(gridmaximize(gridmax));
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
        setgallery(menuinfo.ctrls.indexOf("GALLERY") !== -1); //フォトギャラリ
    }, [menuinfo]);

    function defaulttaglist() {
        if (isEmpty(DicVal(menuinfo, "otherctrls", null))) return inittag;
        var list = DicVal(menuinfo.otherctrls, "TAGKIND", null);
        if (list === null) return inittag;
        var kinds = [];
        for (let i = 0; i < list.length; i++) {
            var ar = list[i].split(":");
            kinds.push({ value: ar[0], label: ar[1] });
        }
        return kinds;
    }

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_prod_code"] = "";
            entrydataRef.current["d_prod_createac"] = "";
            entrydataRef.current["d_prod_createdate"] = "";
            entrydataRef.current["d_prod_updateac"] = "";
            entrydataRef.current["d_prod_update"] = "";
            rerender();
        }
    }, [formstatus]);

    useEffect(() => {
        restoreScrollPos();
    }, [taglist]);


    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                let col = columninfo.find(e => e.columnid === "d_prod_sampleno");
                if (DicVal(col, "dataid", "") !== "d_prod:sample") return;
                clearform();
                if (entrydataRef.current === null) entrydataRef.current = {};
                entrydataRef.current["d_prod_sampleno"] = locationstate.current.acceptno;
                AcceptAction(locationstate.current.acceptno, true);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    if (gridlist[i].id === G_id.SKU || gridlist[i].id === G_id.SKUM) continue;
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function onGridReady(param, panel) {
        if (panel.id === G_id.SKU || panel.id === G_id.SKUM) {
            SetGridApi(panel, param.api);
            SetGridColApi(panel, param.api);
        }
        if (panel.id === G_id.SIZEDTL) {
            //rerender復元
            let data = GridData(panel);
            if (!isEmpty(data)) {
                let col = GridColDef(panel);
                GridApi(panel).setGridOption("columnDefs", col)
                GridApi(panel).setGridOption("rowData", data);
            }
        }
     }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('product/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_prod_memo" in row) data.data.d_prod_memo = row.d_prod_memo;
                                if ("d_prod_sticky" in row) data.data.d_prod_sticky = row.d_prod_sticky;
                                if ("d_prod_mytags" in row) data.data.d_prod_mytags = row.d_prod_mytags;
                            }
                        }
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                        AcceptNo.current.no = data.data["d_prod_sampleno"];
                        //行データ
                        SetGridData({ id: G_id.COL }, data.color.length === 0 ? null : data.color);
                        SetGridData({ id: G_id.SIZE }, data.size.length === 0 ? null : data.size);
                        SetGridData({ id: G_id.SKU }, data.sku.length === 0 ? null : data.sku);

                        if (data.skum.length !== 0) {
                            //サイズ計行
                            let total = 0;
                            let row = { rowid: "total", d_prod_sku_color: "計"};
                            for (let i = 0; i < data.size.length; i++) {
                                let size = data.size[i]['d_prod_size_no'];
                                let sum = data.skum.reduce((sum, obj) => sum + NumConv(obj[size]), 0);
                                row[size] = sum;
                                total += sum;
                            }
                            row['total'] = total;
                            data.skum.push(row);
                            SetGridData({ id: G_id.SKUM }, data.skum);
                        }
                        SetGridData({ id: G_id.SIZEITEM }, data.sizeitem.length === 0 ? null : data.sizeitem);
                        SetGridData({ id: G_id.RAW1 }, data.raw1.length === 0 ? null : data.raw1);
                        SetGridData({ id: G_id.RAW2 }, data.raw2.length === 0 ? null : data.raw2);
                        SetGridData({ id: G_id.RAW3 }, data.raw3.length === 0 ? null : data.raw3);
                        SetGridData({ id: G_id.RAW4 }, data.raw4.length === 0 ? null : data.raw4);
                        SetGridData({ id: G_id.PROCESS }, data.proc.length === 0 ? null : data.proc);
                        SetGridData({ id: G_id.ROW }, data.row.length === 0 ? null : data.row);

                        let tags = defaulttaglist();
                        if (data.tag.length !== 0) {
                            tags = [];
                            for (let i = 0; i < data.tag.length; i++) {
                                tags.push({ value: data.tag[i].d_prod_tag_no, label: data.tag[i].d_prod_tag_name });
                            }
                        }
                        if (data.comp.length !== 0) {
                            SetGridData(G_id.COMP, data.comp.filter(e => e.d_prod_comp_tag === '0'));
                            for (let i = 0; i < tags.length; i++) {
                                compbytagRef.current.push({ no: tags[i].value, data: data.comp.filter(e => e.d_prod_comp_tag === tags[i].value) });
                            }
                        }

                        if (data.wash.length !== 0) {
                            for (let i = 0; i < tags.length; i++) {
                                let wash = [];
                                let list = data.wash.filter(e => e.d_prod_wtag_tag === tags[i].value);
                                for (let j = 0; j < list.length; j++) {
                                    wash.push({
                                        rowid: "0",
                                        mark1: list[j].d_prod_wtag_mark1, mark2: list[j].d_prod_wtag_mark2, mark3: list[j].d_prod_wtag_mark3,
                                        mark4: list[j].d_prod_wtag_mark4, mark5: list[j].d_prod_wtag_mark5, mark6: list[j].d_prod_wtag_mark6,
                                        mark7: list[j].d_prod_wtag_mark7
                                    });
                                }
                                washbytagRef.current.push({ no: tags[i].value, data: wash });
                                if (i === 0) {
                                    SetGridData(G_id.WASH, wash);
                                }
                            }
                        }
                        if (data.attn.length !== 0) {
                            SetGridData(G_id.ATTN, data.attn.filter(e => e.d_prod_attn_tag === '0'));
                            for (let i = 0; i < tags.length; i++) {
                                attnbytagRef.current.push({ no: tags[i].value, data: data.attn.filter(e => e.d_prod_attn_tag === tags[i].value) });
                            }
                        }
                        if (data.deme.length !== 0) {
                            SetGridData(G_id.DEME,  data.deme.filter(e => e.d_prod_deme_tag === '0'));
                            for (let i = 0; i < tags.length; i++) {
                                demebytagRef.current.push({ no: tags[i].value, data: data.deme.filter(e => e.d_prod_deme_tag === tags[i].value) });
                            }
                        }
                        if (data.size.length !== 0) {
                            let size = [];
                            for (let s = 0; s < data.size.length; s++) {
                                size.push(data.size[s].d_prod_size_no);
                            }
                            if (data.sizeitem.length !== 0) {
                                let sizedtl = [];
                                for (let i = 0; i < data.sizeitem.length; i++) {
                                    let item = { "item": data.sizeitem[i].d_prod_sizeitem_item };
                                    for (let s = 0; s < data.size.length; s++) {
                                        let row = data.sizedtl.find(e => e.d_prod_sizedtl_no === data.size[s].d_prod_size_no && e.d_prod_sizedtl_item === data.sizeitem[i].d_prod_sizeitem_item);
                                        item[data.size[s].d_prod_size_no] = !isEmpty(row) ? row.d_prod_sizedtl_value : "";
                                    }
                                    sizedtl.push(item);
                                }
                                //sizedtldataRef.current = sizedtl;
                                SetGridData({ id: G_id.SIZEDTL }, sizedtl);
                                CreateSizeDetail(data.size, data.sizeitem,sizedtl);
                            }
                        }
                        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                            //PL行データ
                            SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                        });
                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        dispatch(setimagelist(data.images));
                        settaglist(tags);
                        settagno("0");

                        if (data.color.length !== 0 && data.size.length !== 0) {
                            if(data.sku.length === 0) CreateSKUData(data.color, data.size);
                            CreateSKUMData(data.color,data.size,data.skum);
                        }

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
               },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function showdata(data) {
        fnc.current.margeMaster(data.master);
        entrydataRef.current = data.data;
        AcceptNo.current.no = data.data["d_prod_sampleno"];

        //行データ
        SetGridData({ id: G_id.COL }, data.color.length === 0 ? null : data.color);
        SetGridData({ id: G_id.SIZE }, data.size.length === 0 ? null : data.size);
        SetGridData({ id: G_id.SKU }, data.sku.length === 0 ? null : data.sku);
        SetGridData({ id: G_id.SKUM }, data.skum.length === 0 ? null : data.skum);
        SetGridData({ id: G_id.RAW1 }, data.raw1.length === 0 ? null : data.raw1);
        SetGridData({ id: G_id.RAW2 }, data.raw2.length === 0 ? null : data.raw2);
        SetGridData({ id: G_id.RAW3 }, data.raw3.length === 0 ? null : data.raw3);
        SetGridData({ id: G_id.RAW4 }, data.raw4.length === 0 ? null : data.raw4);
        SetGridData({ id: G_id.PROCESS }, data.proc.length === 0 ? null : data.proc);
        SetGridData({ id: G_id.ROW }, data.row.length === 0 ? null : data.row);

        let tags = defaulttaglist();
        if (data.tag.length !== 0) {
            tags = [];
            for (let i = 0; i < data.tag.length; i++) {
                tags.push({ value: data.tag[i].d_prod_tag_no, label: data.tag[i].d_prod_tag_name });
            }
        }
        if (data.comp.length !== 0) {
            SetGridData(G_id.COMP, data.comp.filter(e => e.d_prod_comp_tag === '0'));
            for (let i = 0; i < tags.length; i++) {
                compbytagRef.current.push({ no: tags[i].value, data: data.comp.filter(e => e.d_prod_comp_tag === tags[i].value) });
            }
        }

        if (data.wash.length !== 0) {
            for (let i = 0; i < tags.length; i++) {
                let wash = [];
                let list = data.wash.filter(e => e.d_prod_wtag_tag === tags[i].value);
                for (let j = 0; j < list.length; j++) {
                    wash.push({
                        rowid: "0",
                        mark1: list[j].d_prod_wtag_mark1, mark2: list[j].d_prod_wtag_mark2, mark3: list[j].d_prod_wtag_mark3,
                        mark4: list[j].d_prod_wtag_mark4, mark5: list[j].d_prod_wtag_mark5, mark6: list[j].d_prod_wtag_mark6,
                        mark7: list[j].d_prod_wtag_mark7
                    });
                }
                washbytagRef.current.push({ no: tags[i].value, data: wash });
                if (i === 0) {
                    SetGridData(G_id.WASH, wash);
                }
            }
        }
        if (data.attn.length !== 0) {
            SetGridData(G_id.ATTN,  data.attn.filter(e => e.d_prod_attn_tag === '0'));
            for (let i = 0; i < tags.length; i++) {
                attnbytagRef.current.push({ no: tags[i].value, data: data.attn.filter(e => e.d_prod_attn_tag === tags[i].value) });
            }
        }
        if (data.deme.length !== 0) {
            SetGridData(G_id.DEME,  data.deme.filter(e => e.d_prod_deme_tag === '0'));
            for (let i = 0; i < tags.length; i++) {
                demebytagRef.current.push({ no: tags[i].value, data: data.deme.filter(e => e.d_prod_deme_tag === tags[i].value) });
            }
        }
        CreateSKUData(data.color, data.size);
        CreateSKUMData(data.color, data.size, data.skum);

        imageRef.current = data.images;
        fileRef.current = data.files;
        dispatch(setimagelist(data.images));
        settaglist(tags);
        settagno("0");
    }

    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }

    function existPanel(id) {
        let pnl = panel.find(e => e.id === id);
        return pnl !== undefined;
    }
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        for (let i = 0; i < gridlist.length; i++) {
            if (panel !== undefined && panel.id !== gridlist[i].id && panel !== gridlist[i].id) continue;
            SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            if (gridlist[i].id === G_id.COMP) {
                let ref = compbytagRef.current.filter(e => e.no !== tagnoRef.current);
                if (!isEmpty(ref)) {
                    compbytagRef.current = DeepCopy(ref);
                } else {
                    compbytagRef.current = [];
                }
                compbytagRef.current.push({ no: tagnoRef.current, data: GridData(G_id.COMP)});
            }
            if (gridlist[i].id === G_id.WASH) {
                let ref = washbytagRef.current.filter(e => e.no !== tagnoRef.current);
                if (!isEmpty(ref)) {
                    washbytagRef.current = DeepCopy(ref);
                } else {
                    washbytagRef.current = [];
                }
                washbytagRef.current.push({ no: tagnoRef.current, data: GridData(G_id.WASH)});
            }
            if (gridlist[i].id === G_id.ATTN) {
                let ref = attnbytagRef.current.filter(e => e.no !== tagnoRef.current);
                if (!isEmpty(ref)) {
                    attnbytagRef.current = DeepCopy(ref);
                } else {
                    attnbytagRef.current = [];
                }
                attnbytagRef.current.push({ no: tagnoRef.current, data: GridData(G_id.ATTN) });
            }
            if (gridlist[i].id === G_id.DEME) {
                let ref = demebytagRef.current.filter(e => e.no !== tagnoRef.current);
                if (!isEmpty(ref)) {
                    demebytagRef.current = DeepCopy(ref);
                } else {
                    demebytagRef.current = [];
                }
                demebytagRef.current.push({ no: tagnoRef.current, data: GridData(G_id.DEME) });
            }
        //    if (gridlist[i].id === G_id.SIZEDTL) {
        //        SetGridColDef(G_id.SIZEDTL, GridApi(G_id.SIZEDTL).getColumnDefs());
        //    }
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue === '3') {   //SKU
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSavestorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            var type = finallycallback.type;
            if (isEmpty(finallycallback.type)) {
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col === undefined) return;
                type = col.type;
            }
            if (finallycallback.table == "d_prod") {
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    let key = finallycallback.field + "_" + finallycallback.type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let col = columninfo.find(e => e.type === type);
            if (col === undefined) return;
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('product/GetDataTree', { "controller": controller, "code": code, "colinfo": columninfo },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Save(finallycallback, nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        SetPLData();    //PL行データをentrydataRefにセット
        let comp = [];
        if (!EmptyPanel(G_id.COMP)) {
            for (let i = 0; i < compbytagRef.current.length; i++) {
                let data = compbytagRef.current[i].data;
                for (let j = 0; j < data.length; j++) {
                    if (AGRef.current.ExistValidRow([data[j]], columninfo, GridColDef(G_id.COMP))) {
                        data[j]["d_prod_comp_tag"] = compbytagRef.current[i].no;
                        comp.push(data[j]);
                    }
                }
            }
        }
        let wash = [];
        if (existPanel(G_id.WASH)) {
            for (let i = 0; i < washbytagRef.current.length; i++) {
                let data = washbytagRef.current[i].data;
                for (let j = 0; j < data.length; j++) {
                    data[j]["d_prod_wtag_tag"] = washbytagRef.current[i].no;
                    wash.push(data[j]);
                }
            }
        }
        let attn = [];
        if (!EmptyPanel(G_id.ATTN)) {
            for (let i = 0; i < attnbytagRef.current.length; i++) {
                let data = attnbytagRef.current[i].data;
                for (let j = 0; j < data.length; j++) {
                    if (AGRef.current.ExistValidRow([data[j]], columninfo, GridColDef(G_id.ATTN))) {
                        data[j]["d_prod_attn_tag"] = attnbytagRef.current[i].no;
                        attn.push(data[j]);
                    }
                }
            }
        }
        let deme = [];
        if (!EmptyPanel(G_id.DEME)) {
            for (let i = 0; i < demebytagRef.current.length; i++) {
                let data = demebytagRef.current[i].data;
                for (let j = 0; j < data.length; j++) {
                    if (AGRef.current.ExistValidRow([data[j]], columninfo, GridColDef(G_id.DEME))) {
                        data[j]["d_prod_deme_tag"] = demebytagRef.current[i].no;
                        deme.push(data[j]);
                    }
                }
            }
        }
        const paramdata = {
            "controller": controller,
            "data": entrydataRef.current,
            "color": EmptyPanel(G_id.COL) ? null : GridData(G_id.COL),
            "size": EmptyPanel(G_id.SIZE) ? null : GridData(G_id.SIZE),
            "sku": EmptyPanel(G_id.SKU) ? null : GridData(G_id.SKU),
            "skum": EmptyPanel(G_id.SKUM) ? null : GridData(G_id.SKUM),
            "sizeitem": EmptyPanel(G_id.SIZEITEM) ? null : GridData(G_id.SKUITEM),
            "sizedtl": EmptyPanel(G_id.SIZEDTL) ? null : GridData(G_id.SIZEDTL),
            "raw1": EmptyPanel(G_id.RAW1) ? null : GridData(G_id.RAW1),
            "raw2": EmptyPanel(G_id.RAW2) ? null : GridData(G_id.RAW2),
            "raw3": EmptyPanel(G_id.RAW3) ? null : GridData(G_id.RAW3),
            "raw4": EmptyPanel(G_id.RAW4) ? null : GridData(G_id.RAW4),
            "proc": EmptyPanel(G_id.PROCESS) ? null : GridData(G_id.PROCESS),
            "tag": taglist,
            "comp": EmptyPanel(G_id.COMP) ? null :comp,
            "wash": EmptyPanel(G_id.WASH) ? null : wash,
            "attn": EmptyPanel(G_id.ATTN) ? null : attn,
            "deme": EmptyPanel(G_id.DEME) ? null : deme,
            "images": imageRef.current,
            "files": fileRef.current,
            "row": EmptyPanel(G_id.ROW) ? null : GridData(G_id.ROW),
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "product/UpdateEntry" : "product/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            entrydataRef.current["d_prod_code"] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("product", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください", "　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("product/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        imageRef.current = null;
        fileRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        compbytagRef.current = [];
        washbytagRef.current = [];
        attnbytagRef.current = [];
        demebytagRef.current = [];
        AcceptNo.current.no = "";
        if (!isEmpty(GridColDef(G_id.SKUM))) {
            let coldef = GridColDef(G_id.SKUM).filter(e => !isEnabled(DicVal(e.colinfo, 'expansion', false)));    //サイズ項目除外
            SetGridColDef(G_id.SKUM, coldef);
            GridApi(G_id.SKUM).setGridOption('columnDefs', coldef)
        }

        //if (!isEmpty(gridSizeDtlRef.current)) {
        //    GridApi(G_id.SIZEDTL).setGridOption('columnDefs', sizedtlcolDefsInit);
        //    GridApi(G_id.SIZEDTL).setGridOption('rowData', []);
        //}

        scrollRef.current = null;
        dispatch(setimagelist([]));
        settaglist(defaulttaglist());
        settagno("0");
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSavestorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }


    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //ケアラベル
    function caralabelAction(mode) {
        if (mode === 0) {
            fnc.current.formdialogopen({
                title: "ケアラベル追加", inputname: "ラベル名", dialogtype: 0,
                placeholder: "ラベル名を入力してください",
                onApply: (value)=>exec(value)
            });
            function exec(value) {
                if (taglist.find(e => e.label === value) !== undefined) {
                    fnc.current.warnmsg("同一ラベル名が存在します");
                    return;
                } else {
                    let no = value;
                    while (true) {
                        if (taglist.find(e => e.value === no) === undefined) break;
                        no += "1";
                    }
                    let newlist = taglist.concat([{
                        label: value,
                        value: no
                    }]);
                    setcarelabel(no, newlist);
                    fnc.current.formdialogclose();
                }
            }
        }
        if (mode === 1) {
            if (taglist.length === 1) {
                fnc.current.warnmsg("このケアラベルは削除できません");
                return;
            }
            fnc.current.confmsg("表示中のケアラベルを削除します。よろしいですか？", () => exec());
            function exec() {
                let data = compbytagRef.current.filter(e => e.no !== tagnoRef.current);
                compbytagRef.current = data;
                data = washbytagRef.current.filter(e => e.no !== tagnoRef.current);
                washbytagRef.current = data;
                data = attnbytagRef.current.filter(e => e.no !== tagnoRef.current);
                attnbytagRef.current = data;
                data = demebytagRef.current.filter(e => e.no !== tagnoRef.current);
                demebytagRef.current = data;
                let newlist = taglist.filter(e => e.value !== tagnoRef.current);
                setcarelabel(newlist[0].value, newlist);
            }
        }
        if (mode === 2) {
            let tag = taglist.find(e => e.value === tagnoRef.current);
            fnc.current.formdialogopen({
                title: "ケアラベル名の変更", inputname: "ラベル名", dialogtype: 0,
                defaultvalue: tag.label,
                placeholder: "ラベル名を入力してください",
                onApply: (value) => exec(value)
            });
            function exec(value) {
                if (taglist.find(e => e.label === value) !== undefined) {
                    fnc.current.warnmsg("同一ラベル名が存在します");
                    return;
                } else {
                    tag.label = value;
                    let newlist = DeepCopy(taglist);
                    setcarelabel(tagnoRef.current, newlist);
                    fnc.current.formdialogclose();
               }
            }
        }
    }

    function setcarelabel(no, newlist) {
        storeRowData();
        if (!isEmpty(newlist)) {
            settaglist(newlist);
        }
        if (no !== tagnoRef.current) {
            SetGridData(G_id.COMP, null);
            SetGridData(G_id.WASH, null);
            SetGridData(G_id.ATTN, null);
            SetGridData(G_id.DEME, null);
            //該当ケアラベルデータをセット
            let row = compbytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) {
                if (row.data.length === 0) SetGridData(G_id.COMP, [{ rowid: RandomKey() }]);
                else SetGridData(G_id.COMP, row.data);
            }
            fnc.current.rerenderGrid(fnc.current.GridID(G_id.COMP));

            row = washbytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) SetGridData(G_id.WASH, row.data);
            fnc.current.rerenderGrid(fnc.current.GridID(G_id.WASH));

            row = attnbytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) {
                if (row.data.length === 0) SetGridData(G_id.ATTN, [{ rowid: RandomKey() }]);
                else SetGridData(G_id.ATTN, row.data);
            }
            fnc.current.rerenderGrid(fnc.current.GridID(G_id.ATTN));

            row = demebytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) {
                if (row.data.length === 0) SetGridData(G_id.DEME, [{ rowid: RandomKey() }]);
                else SetGridData(G_id.DEME, row.data);
            }
            fnc.current.rerenderGrid(fnc.current.GridID(G_id.DEME));

            settagno(no);
        }
    }
    function settagno(no) {
        tagnoRef.current = no;
        if (!isEmpty(childRef(G_id.COMP))) childRef(G_id.COMP).current?.settagno(no);
        if (!isEmpty(childRef(G_id.WASH))) childRef(G_id.WASH).current?.settagno(no);
        if (!isEmpty(childRef(G_id.ATTN))) childRef(G_id.ATTN).current?.settagno(no);
        if (!isEmpty(childRef(G_id.DEME))) childRef(G_id.DEME).current?.settagno(no);
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
   }

    //リストValueChange
    function ListCellChange(params, columninfo, tabvalue) {
        //簡易計算処理
        var data = null;
        var amountcalc = false;
        if (params.column.colId === "d_prod_raw_baseqty" || params.column.colId === "d_prod_raw_loss") {
            if (columninfo.some(e => e.columnid === "d_prod_raw_baseqty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_raw_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_raw_loss" && e.type === tabvalue)) {
                //d_prod_raw_qty＝d_prod_raw_baseqty×(1 + (d_prod_raw_loss / 100))
                let col = columninfo.find(e => e.columnid === "d_prod_raw_qty" && e.type === tabvalue);
                let qty = NumConv(params.node.data["d_prod_raw_baseqty"]) * (1 + (NumConv(params.node.data["d_prod_raw_loss"]) / 100));
                qty = GetDesitRound(qty, col.rounding, col.decimalplace);
                data = { d_prod_raw_qty: qty }
                amountcalc = true;
            }
        }
        if (params.column.colId === "d_prod_raw_rate" || params.column.colId === "d_prod_raw_currency") {
            if (columninfo.some(e => e.columnid === "d_prod_raw_rate" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_raw_currency" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_raw_price" && e.type === tabvalue)) {
                //d_prod_raw_price＝d_prod_raw_rate×d_prod_raw_currency
                if (NumConv(params.node.data["d_prod_raw_rate"]) !== 0 && NumConv(params.node.data["d_prod_raw_currency"]) !== 0) {
                    let col = columninfo.find(e => e.columnid === "d_prod_raw_price" && e.type === tabvalue);
                    let price = NumConv(params.node.data["d_prod_raw_rate"]) * NumConv(params.node.data["d_prod_raw_currency"]);
                    price = GetDesitRound(price, col.rounding, col.decimalplace);
                    if (data === null) {
                        data = { d_prod_raw_price: price }
                    } else {
                        data['d_prod_raw_price'] = price;
                    }
                    amountcalc = true;
                }
            }
        }
        if (params.column.colId === "d_prod_raw_price" || amountcalc) {
            if (columninfo.some(e => e.columnid === "d_prod_raw_price" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_raw_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_raw_amount" && e.type === tabvalue)) {
                //d_prod_raw_amount=d_prod_raw_qty*d_prod_raw_price
                let col = columninfo.find(e => e.columnid === "d_prod_raw_amount" && e.type === tabvalue);
                let amount = NumConv(params.node.data["d_prod_raw_qty"]) * NumConv(params.node.data["d_prod_raw_price"]);
                amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                if (data === null) {
                    data = { d_prod_raw_amount: amount }
                } else {
                    data['d_prod_raw_amount'] = amount;
                }
            }
        }
        var proccalc = false;
        if (params.column.colId === "d_prod_proc_rate" || params.column.colId === "d_prod_proc_currency") {
            if (columninfo.some(e => e.columnid === "d_prod_proc_rate" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_proc_currency" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_proc_price" && e.type === tabvalue)) {
                //d_prod_proc_price＝d_prod_proc_rate×d_prod_proc_currency
                if (NumConv(params.node.data["d_prod_proc_rate"]) !== 0 && NumConv(params.node.data["d_prod_proc_currency"]) !== 0) {
                    let col = columninfo.find(e => e.columnid === "d_prod_proc_price" && e.type === tabvalue);
                    let price = NumConv(params.node.data["d_prod_proc_rate"]) * NumConv(params.node.data["d_prod_proc_currency"]);
                    price = GetDesitRound(price, col.rounding, col.decimalplace);
                    data = { d_prod_proc_price: price }
                    proccalc = true;
                }
            }
        }
        if (params.column.colId === "d_prod_proc_price" || proccalc) {
            if (columninfo.some(e => e.columnid === "d_prod_proc_price" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_proc_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_prod_proc_amount" && e.type === tabvalue)) {
                //d_prod_proc_amount=d_prod_proc_qty*d_prod_proc_price
                let col = columninfo.find(e => e.columnid === "d_prod_proc_amount" && e.type === tabvalue);
                let amount = NumConv(params.node.data["d_prod_proc_qty"]) * NumConv(params.node.data["d_prod_proc_price"]);
                amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                if (data === null) {
                    data = { d_prod_proc_amount: amount }
                } else {
                    data['d_prod_proc_amount'] = amount;
                }
            }
        }
       return data;
    }
    //＜ダイドー仕様＞ 加工依頼入力で生地品番がセットされた時生地マスタのカラーを初期表示する
    function SetMatlColor() {
        if (!customTarget(corpkey, 'daidoh')) return;
        if (controller.indexOf(":") !== -1) return;     //サンプル除外
        //カラー明細が入力済の場合戻る
        if (!isEmpty(GridData(G_id.COL))) {
            if (GridData(G_id.COL).length !== 0) {
                if (!isEmpty(GridData(G_id.COL)[0]["d_prod_color_no"])) return;
            }
        }
        //１行目の生地コード取得
        if (isEmpty(GridData(G_id.RAW1))) return;
        if (GridData(G_id.RAW1).length === 0) return;
        if (isEmpty(GridData(G_id.RAW1)[0]["d_prod_raw_code"])) return;
        var mtlcode = GridData(G_id.RAW1)[0]["d_prod_raw_code"];
        //生地のカラーを取得
        fnc.current.postaxios('product/GetMatlColor', { "code": mtlcode },
            {
                onSuccess: function (data) {
                    SetGridData(G_id.COL, data.color);
                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.COL));    //再描画
                    CreateSKUData(data.color, sizecollection());
                    CreateSKUMData(data.color, sizecollection());
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }
    function RAW1RowChange() {
        storeRowData(G_id.RAW1);
        SetMatlColor();
    }
    //Grid Data Change
    function ChangeRowValue(params, id) {
        var amountcalc = false;
        if (id === G_id.RAW1 && params.column.colId === "d_prod_raw_code") {
            SetMatlColor();
        }
        if (id === G_id.RAW1 || id === G_id.RAW2 || id === G_id.RAW3 || id=== G_id.RAW4) {
            if (params.column.colId === "d_prod_raw_baseqty" || params.column.colId === "d_prod_raw_loss") {
                if (columninfo.some(e => e.columnid === "d_prod_raw_baseqty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_raw_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_raw_loss" && e.logpid === id) ) {
                    //d_prod_raw_qty＝d_prod_raw_baseqty×(1 + (d_prod_raw_loss / 100))
                    let col = columninfo.find(e => e.columnid === "d_prod_raw_qty" && e.logpid === id);
                    let qty = NumConv(params.node.data["d_prod_raw_baseqty"]) * (1 + (NumConv(params.node.data["d_prod_raw_loss"]) / 100));
                    qty = GetDesitRound(qty, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_prod_raw_qty", qty);
                    amountcalc = true;
                }
            }
            if (params.column.colId === "d_prod_raw_rate" || params.column.colId === "d_prod_raw_currency") {
                if (columninfo.some(e => e.columnid === "d_prod_raw_rate" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_raw_currency" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_raw_price" && e.logpid === id)) {
                    //d_prod_raw_price＝d_prod_raw_rate×d_prod_raw_currency
                    if (NumConv(params.node.data["d_prod_raw_rate"]) !== 0 && NumConv(params.node.data["d_prod_raw_currency"]) !== 0) {
                        let col = columninfo.find(e => e.columnid === "d_prod_raw_price" && e.logpid === id);
                        let price = NumConv(params.node.data["d_prod_raw_rate"]) * NumConv(params.node.data["d_prod_raw_currency"]);
                        price = GetDesitRound(price, col.rounding, col.decimalplace);
                        let node = params.api.getRowNode(params.node.data["rowid"]);
                        node.setDataValue("d_prod_raw_price", price);
                        amountcalc = true;
                    }
                }
            }
            if (params.column.colId === "d_prod_raw_price" || params.column.colId === "d_prod_raw_qty" || amountcalc) {
                if (columninfo.some(e => e.columnid === "d_prod_raw_price" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_raw_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_raw_amount" && e.logpid === id) ){
                    //d_prod_raw_amount=d_prod_raw_qty*d_prod_raw_price
                    let col = columninfo.find(e => e.columnid === "d_prod_raw_amount" && e.logpid === id);
                    let amount = NumConv(params.node.data["d_prod_raw_qty"]) * NumConv(params.node.data["d_prod_raw_price"]);
                    amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_prod_raw_amount", amount);
                }
            }
        }
        if (id === G_id.PROCESS) {
            if (params.column.colId === "d_prod_proc_rate" || params.column.colId === "d_prod_proc_currency") {
                if (columninfo.some(e => e.columnid === "d_prod_proc_rate" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_proc_currency" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_proc_price" && e.logpid === id)) {
                    //d_prod_proc_price＝d_prod_proc_rate×d_prod_proc_currency
                    if (NumConv(params.node.data["d_prod_proc_rate"]) !== 0 && NumConv(params.node.data["d_prod_proc_currency"]) !== 0) {
                        let col = columninfo.find(e => e.columnid === "d_prod_proc_price" && e.logpid === id);
                        let price = NumConv(params.node.data["d_prod_proc_rate"]) * NumConv(params.node.data["d_prod_proc_currency"]);
                        price = GetDesitRound(price, col.rounding, col.decimalplace);
                        let node = params.api.getRowNode(params.node.data["rowid"]);
                        node.setDataValue("d_prod_proc_price", price);
                        amountcalc = true;
                    }
                }
            }
            if (params.column.colId === "d_prod_proc_price" || amountcalc) {
                if (columninfo.some(e => e.columnid === "d_prod_proc_price" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_proc_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_prod_proc_amount" && e.logpid === id)) {
                    //d_prod_proc_amount=d_prod_proc_qty*d_prod_proc_price
                    let col = columninfo.find(e => e.columnid === "d_prod_proc_amount" && e.logpid === id);
                    let amount = NumConv(params.node.data["d_prod_proc_qty"]) * NumConv(params.node.data["d_prod_proc_price"]);
                    amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_prod_proc_amount", amount);
                }
            }
        }
        storeRowData(id);
    }

    //Basic Data Change
    function ValueChanged(id, value) {
        if (id === "d_prod_sampleno") {   //サンプル品番
            let col = columninfo.find(e => e.columnid === id);
            if (DicVal(col, "dataid", "") !== "d_prod:sample") return;
            if (value === AcceptNo.current.no) return;
            if (isEmpty(value)) {
                return;
            }
            AcceptAction(value);
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    //受入処理
    function AcceptAction(value) {
        fnc.current.postaxios('product/GetAccept', { "code": value, "colinfo": columninfo },
            {
                onSuccess: function (data) {
                    data.data["d_prod_code"] = entrydataRef.current["d_prod_code"]
                    clearform();
                    showdata(data);

                    fnc.current.closewarnning();
                    rerender();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    //受入番号を元に戻す
                    entrydataRef.current["d_prod_sampleno"] = AcceptNo.current.no;
                    fnc.current.entryrerender();
                    fnc.current.warnmsg("入力されたサンプル品番は存在しません");
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    //パターンのサイズを取得セット　　ダイドー仕様
    function PatternSizeSet() {
        var ptnno = [];
        GridApi(G_id.ROW).forEachNode((rowNode, index) => {
            if (!isEmpty(rowNode.data.d_prod_row_attribute3)) {
                ptnno.push(rowNode.data.d_prod_row_attribute3);
            }
        });
        if (ptnno.length === 0) {
            fnc.current.warnmsg("パターンNoが入力されていません");
            return;
        }
        fnc.current.confmsg("パターンNoに登録されているサイズをセットします。よろしいですか？", () => exec());
        function exec() {
            fnc.current.postaxios('daidoh/GetPattenSize', { "keys": ptnno},
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        if (data.rowdata.length === 0) {
                            fnc.current.warnmsg("パターンNoに対するサイズが登録されていないか複数パターンの場合共通するサイズが存在しません");
                            return;
                        }
                        SetGridData(G_id.SIZE, data.rowdata);
                        fnc.current.rerenderGrid(fnc.current.GridID(G_id.SIZE));    //再描画
                        let color = colorcollection();
                        if (color.length !== 0 ) {
                            CreateSKUMData(color, data.rowdata);
                        }
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }

    function GridValueChanged(panel, params) {
        storeRowData(panel);
        if (panel.id === G_id.COL) {
            ColorChange(params);
        }
        if (panel.id === G_id.SIZE) {
            SizeChange(params);
        }
        if (panel.id === G_id.SKUM) {
            SkuValueChange(params);
        }
        if (panel.id === G_id.SKU) {
            SizeskuValueChange(params);
        }
        if (panel.id === G_id.SIZEITEM) {
            SizeitemValueChange(params);
        }
        ChangeRowValue(params, panel.id);
    }
    function RowValueChanged(panel, params) {
        if (panel.id === G_id.COL) {
            ColorChange(params);
        }
        if (panel.id === G_id.SIZE) {
            SizeChange(params);
        }
        if (panel.id === G_id.SKUM) {
            SkuValueChange(params);
        }
        if (panel.id === G_id.SKU) {
            SizeskuChange(params);
        }
        if (panel.id === G_id.SIZEITEM) {
            SizeitemChange(params);
        }
        if (panel.id === G_id.RAW1 && customTarget(corpkey, 'daidoh')) {
            RAW1RowChange(params);  //ダイドー仕様
        }
   }
    function ColorChange(param) {
        CreateSKUData();
        CreateSKUMData();
        storeRowData(G_id.COL);
    }
    function SizeChange(param) {
        CreateSKUData();
        CreateSKUMData();
        CreateSizeDetail();
        storeRowData(G_id.SIZE); 
    }
    function SizeitemValueChange(param) {
        if (isEmpty(param.colDef)) return;
        if (param.colDef.field === "d_prod_sizeitem_item") {
            CreateSizeDetail();
        }
        storeRowData(G_id.SIZEITEM);
    }
    function SizeitemChange(param) {
        CreateSizeDetail();
        storeRowData(G_id.SIZEITEM);
    }
    function SKUMRowStyle(param) {
        if (param.data["rowid"] === "total") {
            return { background: totalstylecolor };     //合計行の背景色
        }
    }
    function SkuValueChange(param) {
        if (!isEmpty(param.colDef)) {
            if (param.colDef.colId === "total") return;
        }
        SetMTotalQty();
        storeRowData(G_id.SKUM);
    }
    function SetMTotalQty() {
        let total = 0;
        let sizetotal = [];
        let coldef = GridColDef(G_id.SKUM).filter(e => isEnabled(DicVal(e.colinfo, 'expansion', false)));    //サイズ項目
        GridApi(G_id.SKUM).forEachNode((rowNode, index) => {
            if (rowNode.data["d_prod_sku_color"] === "計") {
                let totaldata = { rowid: 'total', d_prod_sku_color:'計'};
                for (let i = 0; i < coldef.length; i++) {
                    if (coldef[i]['colId'] === "total") continue;
                    totaldata[coldef[i]['colId']] = sizetotal[i];
                }
                totaldata['total'] = total;
                rowNode.setData(totaldata);
            } else {
                let totalrow = 0;
                for (let i = 0; i < coldef.length; i++) {
                    if (coldef[i]['colId'] === "total") continue;
                    let qty = NumConv(DicVal(rowNode.data, coldef[i]['colId'], '0'));
                    totalrow += parseInt(qty);
                    total += parseInt(qty);
                    if (index === 0) {
                        sizetotal.push(parseInt(qty));
                    } else {
                        sizetotal[i] += parseInt(qty);
                    }
                }
                rowNode.setDataValue("total", totalrow);
            }
        });
        let col = columninfo.find(e => e.columnid === "d_prod_qty");
        if (isEmpty(col)) return;
        let entrydata = entrydataRef.current;
        if (entrydata === null) entrydata = { "d_prod_qty": total };
        else entrydata["d_prod_qty"] = total;
        entrydataRef.current = entrydata;
        fnc.current.entryrerender();
    }
    function SizeskuValueChange(param) {
        if (isEmpty(param.colDef)) return;
        if (param.colDef.field === "d_prod_sku_qty") {
            SetTotalQty();
        }
        storeRowData(G_id.SIZESKU);
    }
    function SizeskuChange(param) {
        SetTotalQty();
    }
    function SetTotalQty() {
        let col = columninfo.find(e => e.columnid === "d_prod_qty");
        if (isEmpty(col)) return;
        let key = "d_prod_qty_" + col.type;
        let total = 0;
        GridApi(G_id.SKU).forEachNode((rowNode, index) => {
            if (!isEmpty(rowNode.data.d_prod_sku_qty)) {
                let qty = NumConv(rowNode.data.d_prod_sku_qty);
                total += parseInt(qty);
            }
        });
        document.getElementById(key).value = total;
        let entrydata = entrydataRef.current;
        if (entrydata === null) entrydata = { "d_prod_qty": total};
        else entrydata["d_prod_qty"] = total;
        entrydataRef.current = entrydata;
    }
    function CreateSKUData(color, size) {
        if (EmptyPanel(G_id.SKU)) return;
        if (isEmpty(GridApi(G_id.SKU))) return;    //SKUなし
        if (isEmpty(color)) {
            color = colorcollection();
            size = sizecollection();
        }
         if (color.length === 0 || size.length === 0) {
             GridApi(G_id.SKU).setGridOption('rowData', []);
             SetGridData(G_id.SKU, null);
            return;
        }
        let data = AGRef.current.GetDatasource(GridApi(G_id.SKU));
        let newdata = [];
        for (let i = 0; i < color.length; i++) {
            for (let j = 0; j < size.length; j++) {
                let row = data.find(e => e.d_prod_sku_color === color[i]['d_prod_color_no'] && e.d_prod_sku_size === size[j]['d_prod_size_no']);
                if (isEmpty(row)) {
                    row = { rowid: RandomKey(), d_prod_sku_color: color[i]['d_prod_color_no'], d_prod_sku_size: size[j]['d_prod_size_no'] };
                }
                for (let c = 0; c < GridColDef(G_id.SKU).length; c++) {
                    if (GridColDef(G_id.SKU)[c].field === "rowid") continue;
                    if (!isEmpty(DicVal(color[i],GridColDef(G_id.SKU)[c].field, ''))){
                        row[GridColDef(G_id.SKU)[c].field] = color[i][GridColDef(G_id.SKU)[c].field];
                    }
                    if (!isEmpty(DicVal(size[j],GridColDef(G_id.SKU)[c].field, ''))) {
                        row[GridColDef(G_id.SKU)[c].field]= size[j][GridColDef(G_id.SKU)[c].field];
                    }
                }
                newdata.push(row);
            }
        }
        //GridApi(G_id.SKU).setGridOption('rowData', newdata);
        SetGridData(G_id.SKU, newdata);
        fnc.current.rerenderGrid(fnc.current.GridID(G_id.SKU));    //再描画

    }
    function CreateSKUMData(color, size, data) {     //SKUマトリクス
        if (EmptyPanel(G_id.SKUM)) return;
        if (isEmpty(GridApi(G_id.SKUM))) return;    //SKUマトリクスなし
        if (isEmpty(color)) {
            color = colorcollection();
            size = sizecollection();
        }
        let coldef = GridColDef(G_id.SKUM).filter(e => !isEnabled(DicVal(e.colinfo,'expansion',false)));    //サイズ項目除外
        for (let i = 0; i < size.length; i++) {
            let col = {
                columnid: size[i]['d_prod_size_no'],
                columnnm: size[i]['d_prod_size_no'],
                datatype: "1", logpid: G_id.SKUM, formula: '', decimalplace: 0, expansion:true
            }
            coldef.push({
                colId: size[i]['d_prod_size_no'], field: size[i]['d_prod_size_no'], headerName: size[i]['d_prod_size_no'],
                width: 80,  filter: false, sortable: false, resizable: true, menuTabs: ['generalMenuTab'],
                cellClass: 'ag-right-aligned-cell', colinfo: col,
                editable: function (params) {
                    return params.data['rowid']!=='total';
                }
            });
        }
        if (size.length !== 0) {
            let col = {
                columnid: "total",
                columnnm: "計",
                datatype: "1", logpid: G_id.SKUM, formula: '', decimalplace: 0, expansion: true, locked:true
            }
            coldef.push({
                colId: "total", field: "total", headerName: "計",
                width: 80, editable: false, filter: false, sortable: false, resizable: true, menuTabs: ['generalMenuTab'],
                cellClass: 'ag-right-aligned-cell',
                cellStyle: { color: 'black', 'background-color': totalstylecolor },
                colinfo: col
            });
        }
        SetGridColDef(G_id.SKUM, coldef);

        if (color.length === 0 || size.length === 0) {
            GridApi(G_id.SKUM).setGridOption('rowData', []);
            SetGridData(G_id.SKUM, null);
            return;
        }

        if (isEmpty(data)) {
            data = AGRef.current.GetDatasource(GridApi(G_id.SKUM));
        }
        let newdata = [];
        for (let i = 0; i < color.length; i++) {
            let row = data.find(e => e.d_prod_sku_color === color[i]['d_prod_color_no']);
            if (isEmpty(row)) {
                row = { d_prod_sku_color: color[i]['d_prod_color_no'] };
            }
            //カラー項目をセット
            for (let c = 0; c < coldef.length; c++) {
                if (!isEmpty(DicVal(color[i], coldef[c].field, ''))) {
                    row[coldef[c].field] = color[i][coldef[c].field];
                }
            }
            for (let j = 0; j < size.length; j++) {
                let value = DicVal(row, size[j]['d_prod_size_no'], '');
                if (!isEmpty(value)) {
                    row[size[j]['d_prod_size_no']] = value;
                }
            }
            newdata.push(row);
        }
        if (color.length !== 0) {
            //total
            if (data.some(e => e.rowid === "total")) {
                newdata.push(data.find(e => e.rowid === "total"));
            } else {
                newdata.push({ rowid: 'total', d_prod_sku_color: "計" });
            }
        }
//        GridApi(G_id.SKUM).setGridOption('rowData', newdata);
        SetGridData(G_id.SKUM, newdata);

        fnc.current.rerenderGrid(fnc.current.GridID(G_id.SKUM));    //再描画
    }

    function CreateSizeDetail(size, sizeitem, data) {
        if (EmptyPanel(G_id.SIZEDTL)) return;
        if (isEmpty(gridSizeDtlRef.current)) return;    //サイズ詳細なし

        if (isEmpty(data)) {
            data = AGRef.current.GetDatasource(gridSizeDtlRef.current.api);
            size = sizecollection();
            sizeitem = sizeitemcollection();
        }
        let columns = sizedetailcoldef(size);
        gridSizeDtlRef.current.api.setGridOption('columnDefs', columns);
        if (sizeitem.length === 0 || size.length === 0) {
            gridSizeDtlRef.current.api.setGridOption('rowData', []);
            return;
        }
        let newdata = [];
        for (let i = 0; i < sizeitem.length; i++) {
            let newrow = { rowid: sizeitem[i]['rowid'], item: sizeitem[i]['d_prod_sizeitem_item']};
            let row = data.find(e => e.item === sizeitem[i]['d_prod_sizeitem_item']);
            for (let j = 0; j < size.length; j++) {
                if (isEmpty(row)) {
                    newrow[size[j]['d_prod_size_no']] = '';
                } else {
                    if (size[j]['d_prod_size_no'] in row) newrow[size[j]['d_prod_size_no']] = row[size[j]['d_prod_size_no']];
                    else newrow[size[j]['d_prod_size_no']] = '';
                }
            }
            newdata.push(newrow);
        }
        gridSizeDtlRef.current.api.setGridOption('rowData', newdata);
        SetGridData(G_id.SIZEDTL, newdata);
    }
    function sizedetailcoldef(size) {
        let columns = [
            {
                field: 'item', colId: 'item', headerName: "項目", lockPosition: true,
                width: 200, editable: false, filter: false, sortable: false, resizable: true
            }
        ];
        for (let i = 0; i < size.length; i++) {
            columns.push({
                field: size[i]['d_prod_size_no'], colId: size[i]['d_prod_size_no'], headerName: size[i]['d_prod_size_no'],
                width: 100, editable: true, filter: false, sortable: false, resizable: true, expansion:true
            });
        }
        SetGridColDef(G_id.SIZEDTL, columns);
        return columns;
    }
    function sizeitemcollection() {
        let sizeitem = [];
        GridApi(G_id.SIZEITEM).forEachNode((rowNode, index) => {
            if (rowNode.data === undefined) return;
            if ('d_prod_sizeitem_item' in rowNode.data) {
                if (sizeitem.indexOf(rowNode.data.d_prod_sizeitem_item) === -1) {
                    if (!isEmpty(rowNode.data.d_prod_sizeitem_item)) sizeitem.push(rowNode.data);
                }
            }
        });
        return sizeitem;
    }
    function sizecollection() {
        let size = [];
        GridApi(G_id.SIZE).forEachNode((rowNode, index) => {
            if (size.indexOf(rowNode.data.d_prod_size_no) === -1) {
                if (!isEmpty(rowNode.data.d_prod_size_no)) size.push(rowNode.data);
            }
        });
        return size;
    }
    function colorcollection() {
        let color = [];
        GridApi(G_id.COL).forEachNode((rowNode, index) => {
            if (color.indexOf(rowNode.data.d_prod_color_no) === -1) {
                if (!isEmpty(rowNode.data.d_prod_color_no)) color.push(rowNode.data);
            }
        });
        return color;
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };


    function getMainMenuItems(params) {
        const athleteMenuItems = params.defaultItems.slice(0);
        //pin以外のメニュクリア
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.pop();
        athleteMenuItems.push({
            name: '列幅最適化-すべての列',
            action: () => {
                var allColumnIds = [];
                params.api.getAllGridColumns().forEach(function (column) {
                    if (column.colId !== 'grip')
                        allColumnIds.push(column.colId);
                });
                params.api.autoSizeColumns(allColumnIds, false);
            },
        });
        athleteMenuItems.push({
            name: '列幅最適化-指定列',
            action: () => {
                params.api.autoSizeColumns(params.column.colId, false);
            },
        });
        return athleteMenuItems;
    };
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                        showimage={gallery && props.panel.type==='100'}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.SKUM) {
            return (
                <EntryGrid
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    rowDrag={false}
                    rowContext={false}
                    AutoAddRow={false}
                    ValueChanged={(e) => GridValueChanged(props.panel, e)}
                    RowValueChanged={SkuValueChange}
                    RemoveRow={SkuValueChange}
                    panel={props.panel}
                    getRowStyle={SKUMRowStyle}
                    fillHandleDirection={'xy'}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        if (props.panel.id === G_id.SKU) {
            return (
                <EntryGrid
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    AutoAddRow={false}
                    rowDragManaged={false}
                    rowContext={1}
                    ValueChanged={(e) => GridValueChanged(props.panel, e)}
                    RowValueChanged={SizeskuChange}
                    RemoveRow={SizeskuChange}
                    panel={props.panel}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        if (props.panel.id === G_id.PL) {
            return (
                <EntryGrid
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    ValueChanged={() => storeRowData(props.panel)}
                    panel={props.panel}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        if (props.panel.id === G_id.SIZEDTL) {
            return (
                <div id="sizedtlGrid" className="ag-theme-balham" style={{ width: '100%' }}>
                    <AgGridReact
                        theme={themeBalham}
                        columnMenu="legacy"
                        ref={gridSizeDtlRef}
                        getRowNodeId={(data) => data.item}
                        headerHeight={30}
                        defaultColDef={{
                            filter: true,
                            sortable: true,
                            resizable: true,
                        }}
                        popupParent={document.querySelector('body')}
                        enableRangeSelection={true}
                        suppressMultiRangeSelection={true}
                        getMainMenuItems={getMainMenuItems}
                        suppressContextMenu={true}
                        rowDragManaged={false}
                        domLayout={'autoHeight'}
                        onGridReady={(param) => onGridReady(param, G_id.SIZEDTL)}
                        rowData={[]}
                        columnDefs={sizedtlcolDefsInit}
                    >
                     </AgGridReact>
                </div>
            );
        }
        if (props.panel.id === G_id.WASH) {
            return (
                <WashGrid
                    id={fnc.current.GridID(props.panel)}
                    table="d_prod_wash"
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    type={tabletype(G_id.WASH)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    ValueChanged={() => storeRowData(G_id.WASH)}
                    RowValueChanged={() => storeRowData(G_id.WASH)}
                    RemoveRow={() => storeRowData(G_id.WASH)}
                    panel={props.panel}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            //v1.4
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        if (props.panel.grid) {
            return (
                <EntryGrid
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    ValueChanged={(e) => GridValueChanged(props.panel, e)}
                    RowValueChanged={(e) => RowValueChanged(props.panel, e)}
                    RemoveRow={(e) => RowValueChanged(props.panel, e)}
                    SwapRow={(e) => RowValueChanged(props.panel, e)}
                    panel={props.panel}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        return null;
    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE)  return isEmpty(textfields.find(e => e.type === type));
            if (id === G_id.NB) return isEmpty(columninfo.find(e => e.type === type));
            if (id === G_id.SIZEDTL) return isEmpty(columns.find(e => e.type === tabletype(G_id.SIZE))) || isEmpty(columns.find(e => e.type === tabletype(G_id.SIZEITEM)));
            if (id === G_id.WASH) return false;
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }          

    function maximizeChanged(id, max) {
        const newvalue = JSON.parse(JSON.stringify(GridPanelRef.current));
        newvalue[id] = max;
        GridPanelRef.current = newvalue;
        //ストレージに保存
        Savestorage(corpkey, account, GridPanelStorageKey, GridPanelRef.current);
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom:'300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5, userSelect: 'none'}}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {p.id === G_id.BASE || p.id === G_id.IMAGE || p.id === G_id.NB ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }}>
                                           <GridPanelControl id={fnc.current.GridID(p)} fnc={fnc} gridmaximize={GridPanelRef} ValueChanged={maximizeChanged} />
                                       </div>
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {p.id === G_id.COMP || p.id === G_id.WASH || p.id === G_id.ATTN || p.id === G_id.DEME ?
                                       <div style={{ position: 'absolute', left: 200, top: 0 }}>
                                           <TagControl ref={childRef(p.id)} />
                                       </div>
                                       : null
                                   }
                                   {p.id===G_id.SIZE && customTarget(corpkey, 'daidoh') ?
                                       < div style={{ position: 'absolute', left: 200, top: -8 }}>
                                           <Button size="small" onClick={PatternSizeSet} title={"選択されているパターンNoのサイズをセットします"}
                                               style={{
                                                   width: 120, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 50
                                               }}
                                           >
                                               サイズ初期値セット
                                           </Button>
                                       </div> : null}
                               </div>
                                    <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    function childRef(id) {
        switch (id) {
            case G_id.COMP:
                return childCompRef;
            case G_id.WASH:
                return childWashRef;
            case G_id.ATTN:
                return childAttnRef;
            case G_id.DEME:
                return childDemeRef;
            default:
                return null;
        }
    }
    const TagControl = forwardRef((props, ref) => { 
        const [no, setno] = useState('0');

        useImperativeHandle(ref, () => ({
            settagno(no) {
                setno(no);
            },
        }))

        return (
            <React.Fragment>
                <TextField
                    select
                    hiddenLabel
                    defaultValue={'0'}
                    value={no}
                    onChange={(e) => setcarelabel(e.target.value)}
                    variant="standard"
                    size="small"
                    style={{ width: 150 }}
                    inputProps={{ style: { fontSize: 12 } }}
                >
                    {taglist.map((option) => (
                        <MenuItem key={option.value} value={option.value} style={{ fontSize: 12 }}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
                {
                    entrylock ? null :
                        <React.Fragment>
                            <IconButton size="small" onClick={() => caralabelAction(0)} title="ケアラベル追加">
                                <Icon style={{ fontSize: 16 }}>add_box</Icon>
                            </IconButton>
                            <IconButton size="small" onClick={() => caralabelAction(1)} title="ケアラベル削除">
                                <Icon style={{ fontSize: 16 }}>indeterminate_check_box</Icon>
                            </IconButton>
                            <IconButton size="small" onClick={() => caralabelAction(2)} title="名前の変更">
                                <Icon style={{ fontSize: 16 }}>drive_file_rename_outline</Icon>
                            </IconButton>
                        </React.Fragment>
                }
            </React.Fragment>
        );
    });

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_prod'}
                primarykey={primarykeys}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                listcellchange={ListCellChange}
                masonry={true}
                lockcell={ListlockCell}
            >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={()=>fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210}}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.2,
                            m: 0,
                        }}
                        component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

